import { render, staticRenderFns } from "./modulos.vue?vue&type=template&id=5af99fc4"
import script from "./modulos.vue?vue&type=script&lang=js"
export * from "./modulos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports